<template>
  <div class="main_web_banner">
    <div v-if="languageSelected == 'en'">
      <a href="https://www.labitconf.com/" target="_blank"
        ><img :src="banner" class="banner_web"
      /></a>
      <a href="https://www.labitconf.com/" target="_blank"
        ><img :src="bannerMobile" class="banner_mobile"
      /></a>
    </div>
    <div v-if="languageSelected == 'es'">
      <a href="https://www.labitconf.com/" target="_blank"
        ><img :src="bannerEs" class="banner_web"
      /></a>
      <a href="https://www.labitconf.com/" target="_blank"
        ><img :src="bannerMobileEs" class="banner_mobile"
      /></a>
    </div>
  </div>
</template>
<script>
import banner from "../../assets/images/banner/stratumblue_web_banner.jpg";
import bannerMobile from "../../assets/images/banner/stratumblue_mobile_banner.jpg";
import bannerEs from "../../assets/images/banner/stratumblue_web_banner_es.jpg";
import bannerMobileEs from "../../assets/images/banner/stratumblue_mobile_banner_es.jpg";
import { mapGetters } from "vuex";

export default {
  data: () => ({
    banner: banner,
    bannerMobile: bannerMobile,
    bannerEs: bannerEs,
    bannerMobileEs: bannerMobileEs
  }),
  computed: {
    ...mapGetters(["languageSelected"])
  }
};
</script>
<style lang="scss" scoped>
.main_web_banner {
  width: 100%;
  height: 100%;

  .banner_web {
    width: 100% !important;
  }

  .banner_mobile {
    width: 100% !important;
    display: none;
  }

  @media only screen and (max-width: 880px) {
    .banner_mobile {
      display: block;
    }

    .banner_web {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/WebBanner.vue